import BottomDrawer from "./BottomDrawer";
import logoBazaar from "../../assets/images/logo-bazaar.png";
import logoMyket from "../../assets/images/logo-myket.png";
import logoDirect from "../../assets/images/logo-direct.png";

const STORE_LINKS = [
  {
    id: "bazaar",
    label: "دانلود از بازار",
    href: "https://cafebazaar.ir/app/ir.scab.app?ref=developer_badge",
    icon: logoBazaar,
  },
  {
    id: "myket",
    label: "دانلود از مایکت",
    href: "https://myket.ir/app/ir.scab.app",
    icon: logoMyket,
  },
  {
    id: "direct",
    label: "دانلود مستقیم",
    href: "https://scab.ir/app/SCab_Driver.apk",
    icon: logoDirect,
  },
];

const DEFAULT_MESSAGE =
  "کاربر گرامی اطلاعات شما با موفقیت ثبت شد. برای تکمیل اطلاعات حساب کاربری و اجرای سرویس میتوانید اپلیکیشن را نصب کنید.";

export default function DownloadAppDrawer({
  open,
  onClose,
  onLater,
  showClose = false,
  closeOnBackdrop = false,
  showLater = false,
  laterLabel = "بعدا",
  message = DEFAULT_MESSAGE,
}) {
  const openLink = (href) => {
    window.open(href, "_blank", "noopener,noreferrer");
  };

  return (
    <BottomDrawer
      open={open}
      onClose={onClose}
      showClose={showClose}
      closeOnBackdrop={closeOnBackdrop}
    >
      <p className="text-scabBlack text-medium font-IRANSans leading-8 text-justify mb-5 pt-2">
        {message}
      </p>
      <div className="flex flex-col gap-3">
        {STORE_LINKS.map((item) => (
          <button
            key={item.id}
            type="button"
            className="w-full h-[52px] rounded-[14px] bg-scabBlack text-scabWhite font-IRANSansBold text-medium flex items-center justify-center gap-3"
            onClick={() => openLink(item.href)}
          >
            <img src={item.icon} alt="" className="w-7 h-7 object-contain" />
            <span>{item.label}</span>
          </button>
        ))}
        {showLater ? (
          <button
            type="button"
            className="w-full h-[52px] rounded-[14px] bg-scabDarkYellow text-scabBlack font-IRANSansBold text-medium"
            onClick={onLater || onClose}
          >
            {laterLabel}
          </button>
        ) : null}
      </div>
    </BottomDrawer>
  );
}
